import React, { useState, useEffect } from "react";
import "./Home.css";
import {
  Container,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";

import Header from "../Common/Header/Header";
import StarIcon from "@material-ui/icons/Star";
import PersonIcon from "@material-ui/icons/Person";
import { HttpService } from "../service/HttpService";
import TemporaryDrawer from "../Common/Header/mobile_header";

const Home = (props) => {
  const httpService = new HttpService();
  const history = useHistory();
  const { className } = props;
  const [modal, setModal] = useState(false);
  const [state, setState] = useState(false);
  const [points, setPoints] = useState(0);
  const [role, setRole] = useState("");
  const toggle = () => setModal(!modal);
  const handler = (view) => {
    history.push(view);
  };
  const [user, setUser] = useState({});

  useEffect(() => {
    getUserInfo();
    // getTotalPoints()
  }, []);

  const getUserInfo = () => {
    var obj = {};
    httpService
      .getApi2("account", localStorage.getItem("token"))
      .then((response) => {
        localStorage.setItem("user", JSON.stringify(response.data));
        obj = JSON.stringify(response.data);
        obj = JSON.parse(obj);
        setUser({ ...obj });
        setRole(obj.authorities[0]);
      });
  };

  return (
    <div
      style={{
        backgroundColor: "#eae6e4",
        paddingBottom: role == "ROLE_USER" ? '5%' : '45%'   }}
    >
      <Header isBackBtnShow={true} />
      <div className="home_sec">
        <TemporaryDrawer />

        <div className="text-center">
          {/*================ qr code genrator section =============  */}

          {/* ============= qr code genrator section ==================== */}

          {/* ========== qr code reader section =========  */}
          <div className="reader">
            <Button
              onClick={() => handler("/qrcode")}
              id="qr-reader"
              title="Scan Qr Code"
            >
              {role == "ROLE_VOUCHER_ADMIN"
                ? "Validate Redemption"
                : "Upload points"}
            </Button>
            {/* {state ? <QrContainer /> : ""} */}
          </div>
          {/*=========== qr code reader section ===============  */}

          {/* ================= history section ============ */}
          <div className="history">
            <Button
              onClick={() => handler("/transactions")}
              id="history"
              title="Transaction History"
            >
              History
            </Button>
          </div>
          {/* ================= history section ============ */}
          {role !== "ROLE_VOUCHER_ADMIN" && (
            <div className="redeem">
              <Button
                onClick={() => handler("/company")}
                id="qr-generator"
                title="Redeem Points"
              >
                Redeem
              </Button>
            </div>
          )}

          {/* ================= master barcode section ============ */}
          {role !== "ROLE_VOUCHER_ADMIN" && (
            <div className="identity">
              <p  className="text">If your barcode on bottle is not being read.<br></br>
                  Please use the barcode below</p>
              <Button
                onClick={() => handler("/showBarcode")}
                id="barcode"
                title="Redeem Points"
              >
                Show Barcode
              </Button>
            </div>
          )}

          {/* ================= How to use machine section ============ */}
          {role !== "ROLE_VOUCHER_ADMIN" && (
            <div className="identity">
              <Button
                onClick={() => handler("/playvideo")}
                id="videos"
                title="Redeem Points"
              >
                How to use Machine
              </Button>
            </div>
          )}
          {/* ========== scan container section ==========  */}
          {/* <div className="scan-container">
                    <img src={scannerimg} alt="scanner-imgg" width="90px" height="90px"/>
                    <div className="suggestion-text">
                        <p>Show your ID Code to the scanner to unlock the door and insert your bottles.</p>
                    </div>
                </div> */}
          {/* ========== scan container section ==========  */}
        </div>

        {/* ============ qr code modal =========== */}
        <Modal isOpen={modal} toggle={toggle} className={className}>
          <ModalHeader toggle={toggle}>Modal title</ModalHeader>
          <ModalBody>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={toggle}>
              Do Something
            </Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        {/* ============ qr code modal =========== */}
      </div>
    </div>
  );
};
export default Home;
